import { ComponentPropsWithRef } from "react";

export const SkipIcon = (props: ComponentPropsWithRef<"svg">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="16"
    viewBox="0 0 21 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.3426 7.57384C12.6606 7.76897 12.6606 8.23103 12.3426 8.42616L0.76158 15.5327C0.428428 15.7371 7.24792e-05 15.4974 7.24792e-05 15.1065L7.24792e-05 0.893451C7.24792e-05 0.502575 0.428428 0.262855 0.76158 0.467289L12.3426 7.57384Z"
      fill="currentColor"
    />
    <rect
      x="17.9258"
      y="1.48164"
      width="2.5"
      height="13.037"
      rx="0.4"
      fill="currentColor"
    />
  </svg>
);
